// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__y6fXo","section-1":"styles_section-1__cEYJE","content":"styles_content__6dro2","section-2":"styles_section-2__hHPhu"};